import "../styles/Expired.scss";
import {useLocation, useNavigate} from "react-router-dom";
import {
  BackButton,
  Background,
  CharacterWithBubble,
  LanguageSelector,
} from "../components";
import {path} from "../router/path";
import {ARTIST, getArtistFromPath} from "../utils/artist.utils";
import {useTranslation} from "react-i18next";

const Expired = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const {t} = useTranslation(artist);
  const {t: tCommon} = useTranslation("common");

  const handleBack = () => {
    navigate(path.home(artist));
  };

  return (
    <div className="expired-container">
      <Background artist={artist} />
      <div className="expired-header">
        <BackButton artist={artist} onClick={handleBack} />
        <LanguageSelector artist={artist} />
      </div>
      <div className="expired-content">
        <div className="expired-content-wrapper">
          <CharacterWithBubble
            content={t("expired.farewellMessage")}
            artist={artist}
            character={artist === ARTIST.aespa ? "karangi" : "rizuko"}
          />
          <div className="expired-text">{tCommon("expired.notice")}</div>
        </div>
      </div>
    </div>
  );
};

export default Expired;
